/*
 * Application Insights JavaScript SDK - Core, 3.3.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
export var UNDEFINED_VALUE = undefined;
export var STR_EMPTY = "";
export var STR_CHANNELS = "channels";
export var STR_CORE = "core";
export var STR_CREATE_PERF_MGR = "createPerfMgr";
export var STR_DISABLED = "disabled";
export var STR_EXTENSION_CONFIG = "extensionConfig";
export var STR_EXTENSIONS = "extensions";
export var STR_PROCESS_TELEMETRY = "processTelemetry";
export var STR_PRIORITY = "priority";
export var STR_EVENTS_SENT = "eventsSent";
export var STR_EVENTS_DISCARDED = "eventsDiscarded";
export var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
export var STR_PERF_EVENT = "perfEvent";
export var STR_OFFLINE_STORE = "offlineEventsStored";
export var STR_OFFLINE_SENT = "offlineBatchSent";
export var STR_OFFLINE_DROP = "offlineBatchDrop";
export var STR_GET_PERF_MGR = "getPerfMgr";
export var STR_DOMAIN = "domain";
export var STR_PATH = "path";
export var STR_NOT_DYNAMIC_ERROR = "Not dynamic - ";
//# sourceMappingURL=InternalConstants.js.map